import { Button, Group, Stack, Text } from "@mantine/core";
import { notifications } from "@mantine/notifications";

/**
 * Asks, once after signing in, whether the podcasts followed on this device without an account should be added to
 * the account. Nothing is added until the listener says so, and a refused answer stays on screen to try again.
 */
export const showDeviceFollowsNotice = (count: number, choose: (add: boolean) => Promise<boolean>) => {
    const id = `device-follows-${Date.now()}`;
    const answer = (add: boolean) => async () => {
        const ok = await choose(add);
        if (ok) {
            notifications.hide(id);
        } else {
            notifications.update({ id, color: "red", message: "Det gick inte. Försök igen.", autoClose: false });
        }
    };
    notifications.show({
        id,
        autoClose: false,
        title: "Poddar från den här enheten",
        message: (
            <Stack gap="xs">
                <Text size="sm">
                    Du följde {count === 1 ? "1 podd" : `${count} poddar`} här innan du loggade in. Ska de läggas till
                    på ditt konto?
                </Text>
                <Group gap="xs">
                    <Button onClick={answer(true)} size="compact-sm">
                        Lägg till
                    </Button>
                    <Button onClick={answer(false)} size="compact-sm" variant="subtle">
                        Hoppa över
                    </Button>
                </Group>
            </Stack>
        ),
    });
};
